import styles from "./static-header.module.scss";

export default function StaticHeader() {
  return (
    <div className={styles.logoBar}>
      <img
        className={styles.logo}
        src="/images/logo/logo_black_large.svg"
        alt="Claimable"
      />
    </div>
  );
}
